<ng-container *transloco="let t">
  <pxc-filter-bar
    data-testid="filter-bar"
    [searchPlaceholder]="t('Rechercher un patient par nom, prénom, nip ou DDN ...')" />

  @if (collection$ | async; as collection) {
    @if (isCollectionLoaded$ | async) {
      @if (collection.data.length > 0) {
        <section
          class="flex max-h-[70vh] flex-1 flex-col gap-3 overflow-y-auto"
          data-testid="scroll-viewport"
          scroll-tracker
          [bottomGuard]="collection.context.isNextPageLoading"
          [threshold]="{ bottom: 300 }"
          (bottomThreshold)="loadNextPatients()">
          @if (collection.data.length === 0) {
            <pxc-status
              data-testid="no-result-message"
              icon="search-outline"
              [description]="t('Aucun patient ne correspond à votre recherche.')"
              [state]="Status.BASIC"
              [title]="t('Aucun résultat')" />
          }
          @for (patient of collection.data; track patient.id) {
            <pxc-patient-card
              class="cursor-pointer"
              [attr.data-testid]="'patient-' + patient.id"
              [displayLastActivity]="true"
              [patient]="patient"
              (click)="selectTargetPatient(patient)">
              <pxc-patient-link-quick-action *showIfClientIsGamEnabled="patient" />
              <input
                aria-hidden="true"
                class="pointer-events-none self-center"
                tabindex="-1"
                trailing
                tuiRadio
                type="radio"
                [attr.data-testid]="'patient-radio-' + patient.id"
                [checked]="targetPatient?.id === patient.id" />
            </pxc-patient-card>
          }
          <div class="flex items-center justify-center">
            <pxc-spinner [isVisible]="collection.context.isNextPageLoading" />
          </div>
        </section>
      } @else {
        <pxc-empty-state
          data-testid="no-patient-message"
          [title]="t('Il n\'y a aucun patient disponible pour une fusion.')" />
      }
    } @else {
      <ng-container [ngTemplateOutlet]="loading" />
    }
  } @else {
    <ng-container [ngTemplateOutlet]="loading" />
  }

  <div class="mt-4 flex flex-wrap justify-between gap-2">
    <button
      appearance="outline"
      class="max-md:w-full"
      data-testid="cancel-button"
      tuiButton
      type="button"
      (click)="cancel()">
      {{ t('Annuler') }}
    </button>
    <button
      class="max-md:order-first max-md:w-full"
      data-testid="confirm-button"
      tuiButton
      type="button"
      [disabled]="targetPatient === null"
      (click)="mergePatients()">
      {{ t('Fusionner') }}
    </button>
  </div>

  <ng-template #loading>
    <div class="flex flex-1 items-center justify-center">
      <pxc-loader>{{ t('Chargement des patients...') }}</pxc-loader>
    </div>
  </ng-template>
</ng-container>
